import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../constants';

export const cardStyle: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
	borderRadius: '12px',
	backgroundColor: Colors.white_a5,
	border: `1px solid ${Colors.white_a10}`,
	p: '24px',
	position: 'relative',
};
